module.exports = __webpack_public_path__ + "assets/img/coin.f4f05cad.png";